export default __webpack_public_path__ + "static/media/contact.a0195297.png";